import React from "react";
import { GridRow, GridColumn, LabeledText, LabeledDate } from "sprint-common-web";

import { LabeledRecordTypeBadge } from "../../../../common/components/RecordTypeBadge";
import { LabeledTrailerInfoBadge } from "../../../../common/components/trailer-info/LabeledTrailerInfoBadge";
import { StorageType } from "../../../../common/types/StorageType";
import { LabeledFileRecordStatusDetailsText } from "../../../file-records/common/components/status-details/FileRecordStatusDetailsText";
import { FileRecordDetails } from "../FileRecordDetails";

interface FileRecordLibraryViewProps {
    fileRecordDetails: FileRecordDetails;
}

export const FileRecordLibraryView = ({ fileRecordDetails }: FileRecordLibraryViewProps): JSX.Element => {
    const InfoView = fileRecordDetails.isTrailer && <LabeledTrailerInfoBadge />;

    return (
        <GridRow>
            <GridColumn sm={6}>
                <LabeledRecordTypeBadge value={fileRecordDetails.type} />
                {InfoView}
                <LabeledText
                    label="File path"
                    value={fileRecordDetails.deliveryPath}
                    maxLength={40}
                    testId="file-path-field"
                    textTooltip
                />
                <LabeledText label="Originator" value={fileRecordDetails.originator?.name} testId="originator-field" />
                <LabeledText label="Reference" value={fileRecordDetails.reference} testId="reference-field" />
            </GridColumn>
            <GridColumn sm={6}>
                <LabeledText
                    label="Delivery file name"
                    value={fileRecordDetails.deliveryFileName}
                    maxLength={40}
                    testId="delivery-file-name-field"
                    textTooltip
                />
                <LabeledDate label="Arrival date" value={fileRecordDetails.arrivalDate} testId="arrival-date" />
                <LabeledText
                    label="Storage type"
                    value={StorageType[fileRecordDetails.storageType]}
                    maxLength={40}
                    testId="storage-type-field"
                />
                <LabeledFileRecordStatusDetailsText statusDetails={fileRecordDetails.statusDetails} />
            </GridColumn>
        </GridRow>
    );
};
